let plugins = ['tk', 'index', 'vuexStorage']
if (process.env.VUE_APP_ENV === 'app') {
  plugins = [
    ...plugins,
    'user',
    'routerAuth'
  ]
}
const config = {
  vuexStorageKeys: [
    'sessionToken',
    'user'
  ],
  plugins: plugins,
  apiUrl: 'http://192.168.0.104:3333',
  cloudUrl: 'http://192.168.0.104:3333',
  appID: '',
  restKey: '',
  masterKey: '',
  statusBarColor: 'rgba(255, 255, 255, 0)',
  mobileView: false,
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon'),
  payId: '',
  paysecret: ''
  // moke
  // payId: '15920a19-54ef-4761-956a-2aaeed9386bf',
  // paysecret: '4b378d27-3500-44b4-9c9b-237c9fbe4a59'
}
// config.cloudUrl = 'http://192.168.50.119:3333'
export default config
